/* eslint-disable */
import React, { Component } from "react";
import Chart from "react-apexcharts";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Tooltip,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
  Typography,
  withStyles,
  Icon,
} from '@material-ui/core';
import { useStyles } from '../../style';
import superavitIcon from '../../../../../assets/icons/superavitIcon.svg';
import es from "../../../../../assets/languagePackages/es.json";

export default function ChartDeficit({ data, otherData }) {


  const classes = useStyles();

  const chartData = {
    series: [{
      name: 'Superavit',
      data: data
    }],
    options: {
      chart: {
        locales: [es],
        defaultLocale: 'es',
        fontFamily: 'Roboto, sans-serif',
        type: 'bar',
        height: 200
      },
      dataLabels: {
        enabled: false
      },
      tooltip: {
        enabled: true,
        style: {
          fontFamily: 'Roboto, "sans-serif"',
        },
        custom: function({series, seriesIndex, dataPointIndex, w}) {
          const current = w.config.series[seriesIndex].data[dataPointIndex];
          const entrada = otherData.entradas.find(salObj => salObj[0] === current[0]);
          const salida = otherData.salidas.find(salObj => salObj[0] === current[0]);
          const value = w.config.series[seriesIndex].data[dataPointIndex] !== undefined ? w.config.series[seriesIndex].data[dataPointIndex] : [null,0];
          const prevValue = w.config.series[seriesIndex].data[dataPointIndex-1] !== undefined ? w.config.series[seriesIndex].data[dataPointIndex-1] : [null,0];
          const date = new Date(value[0]);
          const day = String(date.getUTCDate()).padStart(2, '0');
          const month = String(date.getUTCMonth() + 1).padStart(2, '0');
          const year = String(date.getUTCFullYear()).slice(-2);
          const formattedValue = series[seriesIndex][dataPointIndex].toLocaleString(undefined, {
            style: 'currency',
            currency: 'USD',
          });
          const formattedAplicacion = salida[1].toLocaleString(undefined, {
            style: 'currency',
            currency: 'USD',
          });
          const formattedFuentes = entrada[1].toLocaleString(undefined, {
            style: 'currency',
            currency: 'USD',
          });
          const formattedDate = `${day}/${month}/${year}`;
          let backgroundColor = value[1] < prevValue[1] ? '#fac004' : '#024788';
          return `
            <div style="border-radius:5px;font-family:'Roboto',serif;">
                <div style="display:flex;align-items:center;background:#ECEFF1;border-bottom:thin solid #ddd;padding-top:10px;padding-left:10px;padding-right:10px;padding-bottom:5px">
                   <span style="background-color:${backgroundColor}; width:12px; height:12px; border-radius:50%; display:flex;"></span>
                   <p style="margin-left:5px;">Fecha: <span style="font-weight:bold;">${formattedDate}</span></p>
                </div>
                <div style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:5px">
                  <p>Total Fuentes de Efectivo: <span style="font-weight:bold;">${formattedFuentes}</span></p>
                  <p>Total Aplicaciones de Efectivo: <span style="font-weight:bold;">${formattedAplicacion}</span></p>
                  <p>Superávit (Déficit): <span style="font-weight:bold;">${formattedValue}</span></p>
                </div>
            </div>
        `
        }
      },
      colors: [function({ value, seriesIndex, dataPointIndex, w }) {
        const prevValue = w.config.series[seriesIndex].data[dataPointIndex-1] !== undefined ? w.config.series[seriesIndex].data[dataPointIndex-1] : [null,0];
        if (value < prevValue[1]) {
          return '#fac004'
        } else {
          return '#024788'
        }
      }],
      plotOptions: {
        bar: {
          // colors: {
          //   ranges: [
          //     {
          //       from: -Number.MAX_VALUE,
          //       to: 0,
          //       color: '#fac004' // Color para valores negativos
          //     },
          //     {
          //       from: 0,
          //       to: Number.MAX_VALUE,
          //       color: '#024788' // Color para valores positivos
          //     }
          //   ]
          // },
          columnWidth: '75%',
        }
      },
      yaxis: {
        // title: {
        //   text: 'Crecimiento',
        // },
        labels: {
          formatter: function (y) {
            const formattedValue = y.toLocaleString(undefined, {
              style: 'currency',
              currency: 'USD',
            });
            return formattedValue;
          }
        }
      },
      xaxis: {
        type: 'datetime',
        labels: {
          rotate: -90
        }
      }
    },
  };
  
 
  return (

    <Grid component={Card} padding={3}>
      <Grid className={classes.chartLineBarsBox} item xs={12} md={12}>
        <div>
          <img src={superavitIcon} alt="superavitIcon" height="35px" width="35px" />
        </div>
        <Typography className={classes.chartBarDonutText} paddingLeft={2}>
        Superávit (Déficit) de Requerimientos Financieros Acumulativos
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} height={300}>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          width="100%"
          height="100%"
        />
      </Grid>

    </Grid>


  );
}
